import { render } from "./StudentProfile.vue?vue&type=template&id=1ea7638c&scoped=true"
import script from "./StudentProfile.vue?vue&type=script&lang=js"
export * from "./StudentProfile.vue?vue&type=script&lang=js"

import "./StudentProfile.vue?vue&type=style&index=0&id=1ea7638c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea7638c"]])

export default __exports__